<template>
	<div class="sf-flex-column h-100">
		<sf-data-table
			ref="dataTable"
			:pageUnit="pagingInfo.pageUnit"
			:totalSize="pagingInfo.totalSize"
			paging
			:columns="columns"
			:rows="rows"
			:stripe="false"
			:excel="isButton_(scrId, 'EX')"
			selection
			@changedPage="changedPage"
		>
			<template v-slot:actionsLeft>
				<!-- 신규 -->
				<sf-button v-if="isButton_(scrId, 'CC') && (isMmcUser || isMmcAdmin)" line icon="file" :onClick="saveAction">
					{{ getMessage_('QWCC001083') }}
				</sf-button>
				<!-- QR출력 -->
				<sf-button v-if="isButton_(scrId, 'CU') && isMmcAdmin" line icon="download" :onClick="printAction">
					{{ getMessage_('QWCC001326') }}
				</sf-button>
			</template>
		</sf-data-table>
		<!-- pop up -->
		<mes-info-popup ref="mesInfoPopup" @Refresh="refresh" :scrId="scrId"></mes-info-popup>
		<report-popup ref="reportPopup" @Refresh="refresh" :scrId="scrId"></report-popup>
		<!-- ubi 레포트 팝업 -->
		<ubi-report ref="ubiPopup" @Refresh="refresh" :scrId="scrId"></ubi-report>
	</div>
</template>

<script>
import _ from 'lodash';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import MesInfoPopup from '../Popup/MesInfoPopup.vue';
import ReportPopup from '../Report/ReportPopup.vue';
import UbiReport from '@qms/Components/popup/ReportPopup.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { MesInfoPopup, ReportPopup, UbiReport },
	methods: {
		...rootMethods,
		...serviceMethods,
		printAction() {
			const saveListRows = this.$refs.dataTable.getSelectedRows();
			const filteredNrRows = _.filter(saveListRows, { calStCd: 'NR' });
			try {
				if (saveListRows.length < 1) {
					throw new Error(this.getMessage_('QWCC001556')); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
				}
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('QWCC001777'), //출력하시겠습니까?
					buttons: [
						{
							title: this.getMessage_('MWCC001035'),
							clickFn: () => {
								this.reportAction(saveListRows);
								this.save(filteredNrRows);
							}
						}
					] //저장
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message || error });
			}
		},
		//레포트 출력
		async reportAction(saveListRows) {
			let barcodeData = '';
			for (const row of [...saveListRows]) {
				if (row.mesEqipNo) {
					const calCyclNm = row.calCyclCd ? _.find(this.calCyclCdList, { value: row.calCyclCd }).label : ' - ';
					barcodeData += row.mesEqipNo + '^t' + calCyclNm + '^t' + row.calCyclCd + '^n';
				} else continue;
			}
			const sendParams = {
				ubiTarget: this.ubiTarget,
				jrfName: 'barcode_kr.jrf',
				streamdata: 'barcode#"' + barcodeData.substring(0, barcodeData.length - 2) + '"'
			};
			this.$refs.ubiPopup.openWindowReport(sendParams);
		},
		// 신규 인 경우, 교정 상태값 등록으로 변화
		async save(saveRows) {
			if (saveRows && saveRows.length > 0) {
				this.$sf_toggleLoading(true);
				const sendData = {
					status: 2,
					data: saveRows
				};
				try {
					const header = await this.setCalStCdUpdate_(sendData);
					header.code == 0 && this.refresh();
				} catch (error) {
					this.$sf_toast({ type: 'error', message: error.message });
				} finally {
					this.$sf_toggleLoading(false);
				}
			}
		},
		clickMesEqipNo(row) {
			this.$refs.mesInfoPopup.open(row); // open팝업을 실행한다.
		},
		saveAction() {
			this.$refs.mesInfoPopup.open(); // open팝업을 실행한다.
		},
		strangeAction(row) {
			if (!(this.isMmcUser || this.isMmcAdmin)) return;
			this.$refs.reportPopup.open(row);
		},
		refresh() {
			this.$emit('Refresh');
		},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.refresh();
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.resultList;
		},
		columns() {
			return [
				{
					label: this.getMessage_('QWCC001317'), //관리번호
					prop: 'mesEqipNo',
					minWidth: '100px',
					highlight: true,
					clickEvent: this.clickMesEqipNo
				},
				{
					label: this.getMessage_('QWCC001314'), //장비명
					prop: 'mesEqipNm',
					minWidth: '130px'
				},
				{
					label: this.getMessage_('QWCC001318'), //제조사
					prop: 'mkrNm',
					minWidth: '200px'
				},
				{
					label: this.getMessage_('QWCC001319'), //모델명
					prop: 'mdlNm',
					minWidth: '1px'
				},
				{
					label: this.getMessage_('QWCC001320'), //시리얼번호
					prop: 'eqipSn',
					minWidth: '130px'
				},
				{
					label: this.getMessage_('QWCC001321'), //사용부서
					prop: 'useDeptCd',
					minWidth: '1px'
				},
				{
					label: this.getMessage_('QWCC001321'), //사용부서
					prop: 'useDeptNm',
					minWidth: '130px'
				},
				{
					label: this.getMessage_('QWCC000982'), //담당자
					prop: 'user1Id',
					minWidth: '1px'
				},
				{
					label: this.getMessage_('QWCC000982'), //담당자
					prop: 'user1Nm',
					minWidth: '130px'
				},
				{
					label: this.getMessage_('QWCC001347'), //교정비용
					prop: 'calExp',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('QWCC001349') + ' Min', //측정범위최소
					prop: 'mesScpMinVal',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('QWCC001349') + ' Max', //측정범위최대
					prop: 'mesScpMaxVal',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('QWCC001350') + ' Min', //정밀도최소
					prop: 'lodeMinVal',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('QWCC001350') + ' Max', //정밀도최대
					prop: 'lodeMaxVal',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('QWCC001322'), //도입일자
					prop: 'puchDd',
					minWidth: '1px'
				},
				{
					label: this.getMessage_('QWCC001323'), //교정주기
					prop: 'calCyclCd',
					minWidth: '99px',
					form: {
						type: 'select',
						options: this.calCyclCdList,
						placeholder: ' - ',
						isDisabled: () => true // 에디트 방지
					}
				},
				{
					label: this.getMessage_('QWCC001324'), //차기교정일
					prop: 'nextCalDd',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('QWCC002024'), //교정보고서
					prop: 'calWrptYn',
					minWidth: '80px',
					form: {
						type: 'select',
						options: this.ynCdList,
						placeholder: ' - ',
						isDisabled: () => true // 에디트 방지
					}
				},
				{
					label: this.getMessage_('QWCC001628'), //성적서
					prop: 'rslrFileId',
					minWidth: '1px'
				},
				{
					label: this.getMessage_('QWCC001325'), //교정방식
					prop: 'calWayCd',
					minWidth: '80px',
					form: {
						type: 'select',
						options: this.calWayCdList,
						placeholder: ' - ',
						isDisabled: () => true // 에디트 방지
					}
				},
				{
					label: this.getMessage_('QWCC001316'), //교정상태
					prop: 'calStCd',
					minWidth: '80px',
					form: {
						type: 'select',
						options: this.calStCdList,
						placeholder: ' - ',
						isDisabled: () => true // 에디트 방지
					}
				},
				{
					label: this.getMessage_('QWCC001315'), //가동상태
					prop: 'runStCd',
					minWidth: '1px',
					form: {
						type: 'select',
						options: this.runStCdList,
						placeholder: ' - ',
						isDisabled: () => true // 에디트 방지
					}
				},
				{
					label: this.getMessage_('QWCC001315'), //가동상태
					prop: 'runStNm',
					minWidth: '80px',
					highlight: !(this.isMmcUser || this.isMmcAdmin) ? false : true,
					clickEvent: this.strangeAction
				},
				{
					label: this.getMessage_('QWCC001327'), //이상신청
					prop: 'prbmStNm',
					minWidth: '80px'
				},
				{
					label: this.getMessage_('QWCC001327'), //이상신청
					prop: 'prbmStCd',
					minWidth: '1px'
				}
			];
		}
	}
};
</script>
